

































import Vue from 'vue'

import { EventService } from '../../../base/services/EventService'
import WidgetRow from '../base/row/WidgetRow.vue'
import WidgetContainerBreadcrumbs from './WidgetContainerBreadcrumbs.vue'

export default Vue.extend({
  components: {
    WidgetRow,
    WidgetContainerBreadcrumbs
  },
  props: {
    isEditable: {
      type: Boolean,
      default: false
    },
    widget: {
      required: true,
      type: Object
    },
    isRoot: {
      type: Boolean,
      default: false
    },
    dashboardSettings: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      breadcrumbs: []
    }
  },
  watch: {
  },
  computed: {
    localDashboardSettings() {
      return this.dashboardSettings ? this.dashboardSettings : this.widget.dashboardSettings
    },
    orderedRows() {
      if (!this.widget.rows) return

      let orderedRows = JSON.parse(JSON.stringify(this.widget.rows))

      return orderedRows.sort((a, b) => a.sortindex - b.sortindex)
    },
    containerClasses() {
      return {
        'is-editable': this.isEditable,
        'has-outline': !this.isRoot && this.isEditable,
        }
    },
    hasBreadcrumbs() {
      return !this.isRoot && this.breadcrumbs.length
    }
  },
  methods: {
    onPopulateBreadcrumbs(containerUUID, breadcrumbs) {
      if (this.widget.wbUUID !== containerUUID) {
        this.breadcrumbs = []
        return
      }

      this.breadcrumbs = breadcrumbs
    }
  },
  created() {
    EventService.$on('breadcrumbs-populate', this.onPopulateBreadcrumbs)
  },
  destroyed() {
    EventService.$off('breadcrumbs-populate', this.onPopulateBreadcrumbs)
  }
})
